import Api from '@utils/api';
import { Alumnos, AlumnosTramiteDocumentos } from '@constants/urls';

const PREFIJOS = {
	CAMBIO_DE_PLANTEL: 'B',
	COMBALIDADOS: 'C'
};
export const state = {
	isLoading: false,
	isLoadingFormulario: false,
	isLoadingVerificando: false,
	alumno: {},
	documentos: {}
};

export const getters = {
	isLoading: function(state) {
		return state.isLoading;
	},
	isLoadingVerificando: function(state) {
		return state.isLoadingVerificando;
	},
	isLoadingFormulario: function(state) {
		return state.isLoadingFormulario;
	},
	getAlumno: function(state) {
		return state.alumno;
	},
	getStepActive: function(state) {
		return state.alumno.stepActive;
	},
	getDocumentos: function(state) {
		return state.documentos;
	},
	isAlumnoInactivo: function() {
		return !state.alumno.estatus;
	},
	isAlumnoPlanViejo: function(state) {
		const limiteAnio = 9;
		let anioIncripcion = 0;
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		if (
			numeroControl[0].toUpperCase() === PREFIJOS.CAMBIO_DE_PLANTEL ||
			numeroControl[0].toUpperCase() === PREFIJOS.COMBALIDADOS
		) {
			anioIncripcion = parseInt(
				numeroControl[1].toString() + numeroControl[2].toString()
			);
		} else {
			anioIncripcion = parseInt(
				numeroControl[0].toString() + numeroControl[0].toString()
			);
		}
		return anioIncripcion <= limiteAnio;
	},
	isAlumnoDeCambioOCombalidado: function(state, getters) {
		return getters.isAlumnoDeCambioPlantel || getters.isAlumnoCombalidado;
	},
	isAlumnoDeCambioPlantel: function(state) {
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		return numeroControl[0].toUpperCase() === PREFIJOS.CAMBIO_DE_PLANTEL;
	},
	isAlumnoCombalidado: function(state) {
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		return numeroControl[0].toUpperCase() === PREFIJOS.COMBALIDADOS;
	}
};

export const mutations = {
	SET_LOADING: function(state, newValue) {
		state.isLoading = newValue;
	},
	SET_STEP_ACTIVE: function(state, newValue) {
		state.alumno.stepActive = newValue;
	},
	SET_LOADING_VERIFICANDO: function(state, newValue) {
		state.isLoadingVerificando = newValue;
	},
	SET_LOADING_FORMULARIO: function(state, newValue) {
		state.isLoadingFormulario = newValue;
	},
	SET_ALUMNO: function(state, newValue) {
		state.alumno = newValue;
	},
	SET_DOCUMENTOS: function(state, newValue) {
		state.documentos = newValue;
	},
	SET_CORREO_VERIFICADO: function(state, newValue) {
		state.alumno.correoVerificado = newValue;
	}
};

export const actions = {
	establecerLoading: function({ commit }, loading) {
		commit('SET_LOADING', !!loading);
	},
	establecerAlumno: function({ commit }, alumno) {
		commit('SET_ALUMNO', alumno);
	},
	establecerDocumentos: function({ commit }, documentos) {
		commit('SET_DOCUMENTOS', documentos);
	},
	siguientePaso: function({ commit, getters }, callback) {
		commit('SET_LOADING_FORMULARIO', true);
		const stepActive = getters.getStepActive + 1;
		Api.Post(Alumnos.ACTUALIZAR_STEP_ACTIVE(getters.getAlumno.numeroControl), {
			stepActive
		})
			.then(() => {
				callback();
				commit('SET_STEP_ACTIVE', stepActive);
			})
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	},
	obtenerAlumno: function({ commit }, numeroControl = '') {
		commit('SET_LOADING', true);
		Api.Get(Alumnos.OBTENER_POR_NUMERO_CONTROL(numeroControl))
			.then((response) => {
				const alumno = response.data.data;
				commit('SET_ALUMNO', {
					numeroControl: alumno.numeroControl,
					nombre: alumno.nombre,
					apellido_paterno: alumno.apellido_Paterno,
					apellido_materno: alumno.apellido_Materno,
					curp: alumno.curp,
					curpIsEmpty: !alumno.curp,
					carrera: {
						clave: alumno.carrera.id,
						nombre: alumno.carrera.nombre
					},
					telefonos: alumno.telefonos,
					nacionalidad: alumno.nacionalidad.nombre,
					nacionalidadId: alumno.nacionalidad.id || null,
					correoElectronico: alumno.correoElectronico,
					correoElectronicoVerificado: alumno.correoVerificado
						? alumno.correoElectronico
						: '',
					correoVerificado: alumno.correoVerificado,
					opcionTitulacion: alumno.opcionTitulacion.id || null,
					stepActive: alumno.stepActive || 1,
					semestreActual: alumno.semestreActual || 1,
					estatus: alumno.estatus
				});
				Api.Get(
					AlumnosTramiteDocumentos.OBTENER_POR_NUMERO_CONTROL(numeroControl)
				)
					.then((response) => {
						const documentos = response.data.data;
						const obj = {};
						for (let i = 0; i < documentos.length; i++) {
							const documento = documentos[i];
							obj[documento.documentoTitulacion.codigo] = {
								id: documento.id,
								subido: documento.subido,
								verificado: documento.verificado,
								valido: documento.valido,
								nombreArchivo: documento.nombreArchivo,
								urlArchivo: documento.urlArchivo,
								observacion: documento.observacion,
								version: documento.version,
								descripcion: documento.documentoTitulacion.descripcion,
								nota: documento.documentoTitulacion.nota,
								paso: documento.documentoTitulacion.paso
							};
						}
						commit('SET_DOCUMENTOS', obj);
					})
					.finally(() => {
						commit('SET_LOADING', false);
					});
			})
			.finally(() => {
				// commit('SET_LOADING', false);
			});
	},
	verificarCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.ENVIAR_CORREO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 0)
			);
	},
	actualizarDatosAlumno: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.ACTUALIZAR_INFORMACION(numeroControl), params)
			.then(() => {
				onComplete();
			})
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 0)
			);
	},
	reenviarCodigoCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.ENVIAR_CORREO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 0)
			);
	},
	verificarCodigoCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.VERIFICAR_CORREO(numeroControl), params)
			.then(() => {
				commit('SET_CORREO_VERIFICADO', true);
				onComplete();
			})
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 0)
			);
	},
	subirDocumento: function(
		{ commit },
		{
			numeroControl,
			params,
			archivos,
			onComplete = () => {},
			onError = () => {}
		}
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.PostFile(
			AlumnosTramiteDocumentos.SUBIR_DOCUMENTO(numeroControl),
			archivos,
			params
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	}
};
